<div class="file-names">
	<div class="file checkitem-file" *ngFor="let projectFile of checkItem.files; trackBy: trackEntityById">
		<div class="file-icon">
			<!-- <mat-icon>{{getIcon(projectFile.ext)}}</mat-icon> -->
		</div>
		<div class="file-name">
			<span (click)="openFile(projectFile)">{{projectFile?.name}}</span>
			<!-- <a href="{{apiUrl}}/project/{{projectId}}/files/{{projectFile.id}}"
				target="_blank">{{projectFile?.name}}</a> -->
		</div>

		<div class="file-info">
			{{projectFile.uploadTime | date: 'MMM dd, yyyy'}}
		</div>

		<span class="delete-icon" (click)="deleteFile(projectFile)">
			<mat-icon>clear</mat-icon>
		</span>
	</div>
</div>

<mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
</mat-progress-bar>
